import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  styled,
  Typography
} from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import { getAssetUrlFromId, getImageUrlFromId } from "../../helpers/assets";
import { get } from "../../helpers/request";
import useAssetsUpload from "../../hooks/useAssetsUpload";
import useSite from "../../hooks/useSite";
import AssetsUploadInput from "./AssetsUploadInput";
import ImageCard from "./ImageCard";

const GalleryLayout = styled("div")({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, 333px)",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: 32,
});

const getAssetsFn = async ({ queryKey }) =>
  get("/internal/developer/v1/assets?type=image", { site_id: queryKey[1] });

/**
 * @param {{
 *  open: boolean,
 *  onClose: () => void,
 *  onSelected: (assets: Array<{ assetId: string, url: string }>) => void,
 * }} param0
 */
const ImageGallery = ({ open, onClose, onSelected }) => {
  const { site } = useSite();
  const { data } = useQuery(["GET_ASSETS", site?.site_id], getAssetsFn, {
    enabled: open,
  });
  const { inputProps, progress } = useAssetsUpload({
    type: "image",
    onUploaded: ({ assets }) =>      
      onSelected(assets.map(({ assetId, url }) => ({ assetId, url }))),
  });

  const progressPrct = !progress
    ? null
    : Math.round((100 * progress.loaded) / progress.total);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>Galería de Imágenes</DialogTitle>
      <DialogContent>
        <GalleryLayout>
          <div>
            <AssetsUploadInput
              sx={{ height: 194, cursor: "pointer" }}
              uploadLabel="Sube una imagen"
              inputProps={{ ...inputProps, multiple: true }}
            />
            {progressPrct && (
              <>
                <Typography sx={{ mt: 1 }}>Subiendo {progressPrct}%</Typography>
                <LinearProgress
                  variant="determinate"
                  color="secondary"
                  value={progressPrct}
                />
              </>
            )}
          </div>
          {data?.assets?.map((asset) => {
            const isSvg = asset.metadata?.fileName?.endsWith(".svg");
            const assetId = asset.asset_id;
            const url = isSvg
              ? getAssetUrlFromId(asset.asset_id)
              : getImageUrlFromId(asset.asset_id);
            return (
              <ImageCard
                assetId={assetId}
                metadata={asset.metadata}
                url={url}
                onSelected={() => onSelected([{ assetId, url }])}
              />
            );
          })}
        </GalleryLayout>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose}>
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImageGallery;
